export const ITEMS_PER_PAGE = 5;
export const EMAIL_VALIDATION_REGEX = /\S+@\S+\.\S+/;
export const FORGOT_PASSWORD_CODE_LENGTH = 6;
export const FORGOT_PASSWORD_CODE_LENGHT = 6;
export const DAYS_IN_ONE_YEAR = 365;
export const ADVANCED_ITEMS_PER_PAGE = 7;
export const SPEEDS = [9600, 19200, 38400, 57600, 115200];
export const PORT_NUMBER_REG_EXP = new RegExp(/-?\d*\.?\d{1,2/);
export const PORTS = [
    "COM1",
    "COM2",
    "COM3",
    "COM4",
    "COM5",
    "COM6",
    "COM7",
    "COM8",
    "COM9",
];

const expressionIP = /^(?!0|\s)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/i;
const expressionLocalHost = /^localhost$/i;

export const ipMatchWord = new RegExp(
    `(${expressionIP.source})|(${expressionLocalHost.source})`
);
export const numberPositiveMatch = /^\+?\d+(\.\d+)?$/;

export const emailMatchWord = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
export const httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
export const numberMatchWord = new RegExp(/^[1-9]\d*$/);
export const numberMatchWordWithNullInLeft = new RegExp(/^(0*[1-9]\d*)$/);
export const DEFAULT_TIMEOUT_IN_SECONDES = 3;
export const MIN_TIMEOUT_IN_SECONDES = 0;
export const languages = [
    { value: "fr", label: "French" },
    { value: "en", label: "English" },
    { value: "nl", label: "German" },
    { value: "es", label: "Spanish" },
    { value: "it", label: "Italian" },
    { value: "pt", label: "Portuguese" },
];
export const allLanguages = [
    "Albanais",
    "Allemand",
    "Afrikaans",
    "Araona",
    "Azéri",
    "Amazigh",
    "Arménien",
    "Aymara",
    "Anglais",
    "Arabe",
    "Bengali",
    "Bulgare",
    "Bésiro",
    "Bichelamar",
    "Biélorusse",
    "Birman",
    "Catalan",
    "Coréen",
    "Croate",
    "Cambodgien",
    "Chinois",
    "Danois",
    "Espagnol",
    "Finnois",
    "Français",
    "Japonais",
    "Portugais",
    "Russe",
    "Guarani",
    "Grec",
    "Hongrois",
    "Italien",
    "Kikongo",
    "Kiswahili",
    "Lingala",
    "Malais",
    "Mongol",
    "Néerlandais",
    "Occitan",
    "Ourdou",
    "Persan",
    "Quechua",
    "Roumain",
    "Samoan",
    "Serbe",
    "Sesotho",
    "Slovaque",
    "Slovène",
    "Suédois",
    "Tamoul",
    "Turc",
    "Canichana",
    "Cavineña",
    "Cayubaba",
    "Chácobo",
    "Chichewa",
    "Chimane",
    "Créole de Guinée-Bissau",
    "Créole haïtien",
    "Créole seychellois",
    "Divehi",
    "Dzongkha",
    "Ese 'ejja",
    "Estonien",
    "Éwé",
    "Fidjien",
    "Filipino",
    "Géorgien",
    "Gilbertin",
    "Guarasu'we",
    "Guarayu",
    "Hébreu",
    "Hindi",
    "Hindi des Fidji",
    "Hiri motu",
    "Indonésien",
    "Irlandais",
    "Islandais",
    "Itonama",
    "Kallawaya",
    "Kabiyè",
    "Kazakh",
    "Khmer",
    "Kirghiz",
    "Kirundi",
    "Lao",
    "Néo-zélandaise",
    "Papouasienne",
    "Latin",
    "Leko",
    "Letton",
    "Lituanien",
    "Luxembourgeois",
    "Macédonien",
    "Machineri",
    "Malgache",
    "Maltais",
    "Maori",
    "Maori des Îles Cook",
    "Maropa",
    "Marshallais",
    "Mirandais",
    "Mojeño-Trinitario",
    "Mojeño-Ignaciano",
    "Monténégrin",
    "Moré",
    "Mosetén",
    "Movima",
    "Nauruan",
    "Ndébélé du Transvaal",
    "Népalais",
    "Norvégien",
    "Ouzbek",
    "Pacahuara",
    "Pachto",
    "Paluan",
    "Polonais",
    "Puquina",
    "Sango",
    "Shikomor",
    "Shona",
    "Shuar",
    "Sindebele",
    "Singhalais",
    "Sirionó",
    "Somali",
    "Sotho du Nord",
    "Sotho du Sud",
    "Tacana",
    "Tadjik",
    "Tamazight",
    "Tapiete",
    "Tchèque",
    "Tétoum",
    "Tigrinya",
    "Thaï",
    "Tok pisin",
    "Tongien",
    "Toromona",
    "Turkmène",
    "Tuvaluan",
    "Ukrainien",
    "Uru-Chipaya",
    "Vietnamien",
    "Wichi",
    "Yaminahua",
    "Yuki",
    "Yaracaré",
    "Zamuco",
    "Zoulou",
    "Adyguéen",
    "Agul",
    "Altaï",
    "Assamais",
    "Avar",
    "Bachkir",
    "Bas saxon",
    "Basque",
    "Bouriate",
    "Cantonais",
    "Carolinien",
    "Chamorro",
    "Darguine",
    "Erzya",
    "Galicien",
    "Gallois",
    "Gwich'in",
    "Hawaïen",
    "Iakoute",
    "Ingouche",
    "Inuinnaqtun",
    "Inuktitut",
    "Kabarde",
    "Kalmouk",
    "Karatchaï-balkar",
    "Khakasse",
    "Komi",
    "Koumyk",
    "Lak",
    "Lezghien",
    "Mannois",
    "Mari",
    "Moksa",
    "Nogaï",
    "Occitan (aranais)",
    "Ossète",
    "Oudmourte",
    "Ouïghour",
    "Romanche",
    "Routoul",
    "Ruthène",
    "Same",
    "Sorabe",
    "Swati",
    "Tabassaran",
    "Tat",
    "Tatare",
    "Tchétchène",
    "Tchouvache",
    "Tibétain",
    "Tobi",
    "Touvain",
    "Tsakhur",
    "Tsonga",
    "Tswana",
    "Venda",
    "Xhosa",
];

export const TOP_BANNER_LOGO_PRINTER_OPTIONS_TAB = 0;
export const HEADER_PRINTER_OPTIONS_TAB = 1;
export const EMAIL_CONFIRMATION_PRINTER_OPTIONS_TAB = 2;
export const WITH_EMAIL_PRINTER_OPTIONS_TAB = 0;
export const WITHOUT_EMAIL_PRINTER_OPTIONS_TAB = 1;
export const VERIFICATION_EMAIL_PRINTER_OPTIONS_TAB = 0;
export const ENTRY_EMAIL_PRINTER_OPTIONS_TAB = 1;
export const UID_ENTER_BUTTON = "fb60d068-b372-4537-afd1-bb18d42da854";
export const UID_SCAN_BUTTON = "049c04b4-9b01-42a6-8497-8b2a2aedd2d3";
export const UID_USE_BUTTON = "bbf6b88b-b5f4-438f-b8b0-0c7827083b53";
export const UID_LOGOUT_BUTTON = "4bb339a4-ec7b-4d66-9fb0-9e71c1d6d983";
export const UID_SELECT_BUTTON = "c3f52255-7cd6-4024-b784-52a79172254a";

export const VALIDATE_BUTTON_ROLE = 1;
export const NO_THANKS_BUTTON_ROLE = 17;
export const HAS_NO_LOYALTY = 0;
export const CESAR_LOYALTY = 1;
export const SYNAPSY_LOYALTY = 2;
export const ZEROSIX_LOYALTY = 3;
export const GODIA_LOYALTY = 4;
export const POS_EDITOR_CESAR = "10089f6a-879e-4b6d-a7e8-41815fd25a7c";
export const POS_EDITOR_TCPOS = "10c6533d-d0ef-45a1-a549-795253673b7d";
export const AdyenCurrencies = [
    { code: "AED", name: "UAE Dirham", decimals: 2 },
    { code: "ALL", name: "Albanian Lek", decimals: 2 },
    { code: "AMD", name: "Armenian Dram", decimals: 2 },
    { code: "ANG", name: "Antillian Guilder", decimals: 2 },
    { code: "AOA", name: "Angolan Kwanza", decimals: 2 },
    { code: "ARS", name: "Nuevo Argentine Peso", decimals: 2 },
    { code: "AUD", name: "Australian Dollar", decimals: 2 },
    { code: "AWG", name: "Aruban Guilder", decimals: 2 },
    { code: "AZN", name: "Azerbaijani manat", decimals: 2 },
    {
        code: "BAM",
        name: "Bosnia and Herzegovina Convertible Marks",
        decimals: 2,
    },
    { code: "BBD", name: "Barbados Dollar", decimals: 2 },
    { code: "BDT", name: "Bangladesh Taka", decimals: 2 },
    { code: "BGN", name: "New Bulgarian Lev", decimals: 2 },
    { code: "BHD", name: "Bahraini Dinar", decimals: 3 },
    { code: "BMD", name: "Bermudian Dollar", decimals: 2 },
    { code: "BND", name: "Brunei Dollar", decimals: 2 },
    { code: "BOB", name: "Bolivia Boliviano", decimals: 2 },
    { code: "BRL", name: "Brazilian Real", decimals: 2 },
    { code: "BSD", name: "Bahamian Dollar", decimals: 2 },
    { code: "BWP", name: "Botswana Pula", decimals: 2 },
    { code: "BYN", name: "New Belarusian Ruble", decimals: 2 },
    { code: "BZD", name: "Belize Dollar", decimals: 2 },
    { code: "CAD", name: "Canadian Dollar", decimals: 2 },
    { code: "CHF", name: "Swiss Franc", decimals: 2 },
    { code: "CLP", name: "Chilean Peso", decimals: 2 },
    { code: "CNH", name: "Yuan Renminbi (offshore)", decimals: 2 },
    { code: "CNY", name: "Yuan Renminbi (onshore)", decimals: 2 },
    { code: "COP", name: "Colombian Peso", decimals: 2 },
    { code: "CRC", name: "Costa Rican Colon", decimals: 2 },
    { code: "CUP", name: "Cuban Peso", decimals: 2 },
    { code: "CVE", name: "Cape Verdi Escudo", decimals: 0 },
    { code: "CZK", name: "Czech Koruna", decimals: 2 },
    { code: "DJF", name: "Djibouti Franc", decimals: 0 },
    { code: "DKK", name: "Danish Krone", decimals: 2 },
    { code: "DOP", name: "Dominican Republic Peso", decimals: 2 },
    { code: "DZD", name: "Algerian Dinar", decimals: 2 },
    { code: "EGP", name: "Egyptian Pound", decimals: 2 },
    { code: "ETB", name: "Ethiopian Birr", decimals: 2 },
    { code: "EUR", name: "Euro", decimals: 2 },
    { code: "FJD", name: "Fiji Dollar", decimals: 2 },
    { code: "FKP", name: "Falkland Islands Pound", decimals: 2 },
    { code: "GBP", name: "Pound Sterling", decimals: 2 },
    { code: "GEL", name: "Georgian Lari", decimals: 2 },
    { code: "GHS", name: "Ghanaian Cedi (3rd)", decimals: 2 },
    { code: "GIP", name: "Gibraltar Pound", decimals: 2 },
    { code: "GMD", name: "Gambia Delasi", decimals: 2 },
    { code: "GNF", name: "Guinea Franc", decimals: 0 },
    { code: "GTQ", name: "Guatemala Quetzal", decimals: 2 },
    { code: "GYD", name: "Guyanese Dollar", decimals: 2 },
    { code: "HKD", name: "Hong Kong Dollar", decimals: 2 },
    { code: "HNL", name: "Honduras Lempira", decimals: 2 },
    { code: "HTG", name: "Haitian Gourde", decimals: 2 },
    { code: "HUF", name: "Hungarian Forint", decimals: 2 },
    { code: "IDR", name: "Indonesian Rupiah", decimals: 0 },
    { code: "ILS", name: "New Israeli Scheqel", decimals: 2 },
    { code: "INR", name: "Indian Rupee", decimals: 2 },
    { code: "IQD", name: "Iraqi Dinar", decimals: 3 },
    { code: "ISK", name: "Iceland Krona", decimals: 2 },
    { code: "JMD", name: "Jamaican Dollar", decimals: 2 },
    { code: "JOD", name: "Jordanian Dinar", decimals: 3 },
    { code: "JPY", name: "Japanese Yen", decimals: 0 },
    { code: "KES", name: "Kenyan Shilling", decimals: 2 },
    { code: "KGS", name: "Kyrgyzstan Som", decimals: 2 },
    { code: "KHR", name: "Cambodia Riel", decimals: 2 },
    { code: "KMF", name: "Comoro Franc", decimals: 0 },
    { code: "KRW", name: "South-Korean Won", decimals: 0 },
    { code: "KWD", name: "Kuwaiti Dinar", decimals: 3 },
    { code: "KYD", name: "Cayman Islands Dollar", decimals: 2 },
    { code: "KZT", name: "Kazakhstani Tenge", decimals: 2 },
    { code: "LAK", name: "Laos Kip", decimals: 2 },
    { code: "LBP", name: "Lebanese Pound", decimals: 2 },
    { code: "LKR", name: "Sri Lanka Rupee", decimals: 2 },
    { code: "LYD", name: "Libyan Dinar", decimals: 3 },
    { code: "MAD", name: "Moroccan Dirham", decimals: 2 },
    { code: "MDL", name: "Moldovia Leu", decimals: 2 },
    { code: "MKD", name: "Macedonian Denar", decimals: 2 },
    { code: "MMK", name: "Myanmar Kyat", decimals: 2 },
    { code: "MNT", name: "Mongolia Tugrik", decimals: 2 },
    { code: "MOP", name: "Macau Pataca", decimals: 2 },
    { code: "MRU", name: "Mauritania Ouguiya", decimals: 2 },
    { code: "MUR", name: "Mauritius Rupee", decimals: 2 },
    { code: "MVR", name: "Maldives Rufiyaa", decimals: 2 },
    { code: "MWK", name: "Malawi Kwacha", decimals: 2 },
    { code: "MXN", name: "Mexican Peso", decimals: 2 },
    { code: "MYR", name: "Malaysian Ringgit", decimals: 2 },
    { code: "MZN", name: "Mozambican Metical", decimals: 2 },
    { code: "NAD", name: "Namibian Dollar", decimals: 2 },
    { code: "NGN", name: "Nigerian Naira", decimals: 2 },
    { code: "NIO", name: "Nicaragua Cordoba Oro", decimals: 2 },
    { code: "NOK", name: "Norwegian Krone", decimals: 2 },
    { code: "NPR", name: "Nepalese Rupee", decimals: 2 },
    { code: "NZD", name: "New Zealand Dollar", decimals: 2 },
    { code: "OMR", name: "Rial Omani", decimals: 3 },
    { code: "PAB", name: "Panamanian Balboa", decimals: 2 },
    { code: "PEN", name: "Peruvian Nuevo Sol", decimals: 2 },
    { code: "PGK", name: "New Guinea Kina", decimals: 2 },
    { code: "PHP", name: "Philippine Peso", decimals: 2 },
    { code: "PKR", name: "Pakistan Rupee", decimals: 2 },
    { code: "PLN", name: "New Polish Zloty", decimals: 2 },
    { code: "PYG", name: "Paraguay Guarani", decimals: 0 },
    { code: "QAR", name: "Qatari Rial", decimals: 2 },
    { code: "RON", name: "New Romanian Lei", decimals: 2 },
    { code: "RSD", name: "Serbian Dinar", decimals: 2 },
    { code: "RUB", name: "Russian Ruble", decimals: 2 },
    { code: "RWF", name: "Rwanda Franc", decimals: 0 },
    { code: "SAR", name: "Saudi Riyal", decimals: 2 },
    { code: "SBD", name: "Solomon Island Dollar", decimals: 2 },
    { code: "SCR", name: "Seychelles Rupee", decimals: 2 },
    { code: "SEK", name: "Swedish Krone", decimals: 2 },
    { code: "SGD", name: "Singapore Dollar", decimals: 2 },
    { code: "SHP", name: "St. Helena Pound", decimals: 2 },
    { code: "SLE", name: "Sierra Leone Leone", decimals: 2 },
    { code: "SOS", name: "Somalia Shilling", decimals: 2 },
    { code: "SRD", name: "Surinamese dollar", decimals: 2 },
    { code: "STN", name: "Sao Tome & Principe Dobra", decimals: 2 },
    { code: "SVC", name: "El Salvador Colón", decimals: 2 },
    { code: "SZL", name: "Swaziland Lilangeni", decimals: 2 },
    { code: "THB", name: "Thai Baht", decimals: 2 },
    { code: "TND", name: "Tunisian Dinar", decimals: 3 },
    { code: "TOP", name: "Tonga Pa'anga", decimals: 2 },
    { code: "TRY", name: "New Turkish Lira", decimals: 2 },
    { code: "TTD", name: "Trinidad & Tobago Dollar", decimals: 2 },
    { code: "TWD", name: "New Taiwan Dollar", decimals: 2 },
    { code: "TZS", name: "Tanzanian Shilling", decimals: 2 },
    { code: "UAH", name: "Ukraine Hryvnia", decimals: 2 },
    { code: "UGX", name: "Uganda Shilling", decimals: 0 },
    { code: "USD", name: "US Dollars", decimals: 2 },
    { code: "UYU", name: "Peso Uruguayo", decimals: 2 },
    { code: "UZS", name: "Uzbekistani Som", decimals: 2 },
    { code: "VEF", name: "Venezuelan Bolívar", decimals: 2 },
    { code: "VND", name: "Vietnamese New Dong", decimals: 0 },
    { code: "VUV", name: "Vanuatu Vatu", decimals: 0 },
    { code: "WST", name: "Samoan Tala", decimals: 2 },
    { code: "XAF", name: "CFA Franc BEAC", decimals: 0 },
    { code: "XCD", name: "East Caribbean Dollar", decimals: 2 },
    { code: "XOF", name: "CFA Franc BCEAO", decimals: 0 },
    { code: "XPF", name: "CFP Franc", decimals: 0 },
    { code: "YER", name: "Yemeni Rial", decimals: 2 },
    { code: "ZAR", name: "South African Rand", decimals: 2 },
    { code: "ZMW", name: "Zambian Kwacha", decimals: 2 },
];

export const ACCOUNT_CREATION_ID = "4a9de408-6c96-479d-9859-b5f02459f5c9";

export const ACCOUNT_CREATION_ITEM = {
    id: "4a9de408-6c96-479d-9859-b5f02459f5c9",
    name: "Create an account",
    active: true,
    languages: {
        en: {
            name: "Create an account",
            content: "createAnAccount.png",
            isTextVisible: true,
            defaultContent: "Create an account",
        },
        es: {
            name: "Crea una cuenta",
            content: "createAnAccount.png",
            isTextVisible: true,
            defaultContent: "Crea una cuenta",
        },
        fr: {
            name: "Créer un compte",
            content: "createAnAccount.png",
            isTextVisible: true,
            defaultContent: "Créer un compte",
        },
        it: {
            name: "Creare un account",
            content: "createAnAccount.png",
            isTextVisible: true,
            defaultContent: "Creare un account",
        },
        nl: {
            name: "Ein Konto erstellen",
            content: "createAnAccount.png",
            isTextVisible: true,
            defaultContent: "Ein Konto erstellen",
        },
        pt: {
            name: "Crie a sua conta aqui",
            content: "createAnAccount.png",
            isTextVisible: true,
            defaultContent: "Crie a sua conta aqui",
        },
    },
    shortName: "accountFidelite",
};

export const ID_SALE_SUPPORT_KIOSK = "3ef7df0f-6a8e-4470-8851-8978e0ba71c2";
export const errorTypes = [
    "hasInactiveButHasData",
    "hasActiveButMissingData",
    "hasUndefinedButHasData",
];

export const INITIAL_TEMPLATE = {
    id: "",
    name: "",
    coverImage: "",
    pages: {
        elements: {},
        ways: {},
        subSteps: {},
    },
    content: {
        salesMethods: { items: [] },
        meansOfPayment: { items: [] },
        informationModes: { items: [] },
        printerOptions: { items: [] },
        options: { active: true, items: [] },
        actionsButtons: {
            active: true,
            items: [
                {
                    id: "",
                    name: "",
                    active: true,
                    languages: {
                        fr: {
                            content: "",
                        },
                        en: {
                            content: "",
                        },
                    },
                    role: 1,
                },
            ],
        },
        languages: {
            active: true,
            items: [
                {
                    id: "",
                    flag: "",
                    name: "",
                    title: "",
                    language: "",
                    active: true,
                    isDefault: false,
                },
            ],
        },
        generalDesign: {
            logo: {
                id: "",
                name: "",
                content: "l",
            },
            prm: {
                id: "",
                name: "",
                content: "l",
                defaultContent: "",
                type: "",
                timeout: 0,
            },
            colors: [],
            fonts: [],
        },
    },
    timeout: 15,
    initialStepTimeout: 10,
    keyboard: "azerty",
    autoLaunch: true,
};

export const INITIAL_FILES = [
    {
        name: "",
        id: "",
        content: "",
        type: "",
        timeout: 0,
        key: "",
        subName: "",
        defaultImage: "",
    },
];

export const INITIAL_PAYMENT_METHOD = [
    {
        id: "1222cfd3-0300-415d-a426-08c8d027de57",
        name: "At the counter",
        active: true,
        languages: {
            en: {
                name: "At the counter",
                content: "atTheCounter.png",
                isTextVisible: true,
                defaultContent: "At the counter",
            },
            es: {
                name: "En el mostrador",
                content: "atTheCounter.png",
                isTextVisible: true,
                defaultContent: "En el mostrador",
            },
            fr: {
                name: "Au comptoir",
                content: "atTheCounter.png",
                isTextVisible: true,
                defaultContent: "Au comptoir",
            },
            it: {
                name: "Al banco",
                content: "atTheCounter.png",
                isTextVisible: true,
                defaultContent: "Al banco",
            },
            nl: {
                name: "Am Tresen",
                content: "atTheCounter.png",
                isTextVisible: true,
                defaultContent: "Am Tresen",
            },
            pt: {
                name: "No balcão",
                content: "atTheCounter.png",
                isTextVisible: true,
                defaultContent: "No balcão",
            },
        },
        shortName: "atTheCounter",
    },
    {
        id: "5f8ea633-0d6f-49d5-aa02-eb056de50060",
        name: "BDP",
        active: true,
        languages: {
            en: {
                name: "BDP",
                content: "BDP.png",
                isTextVisible: true,
                defaultContent: "BDP",
            },
            es: {
                name: "BDP",
                content: "BDP.png",
                isTextVisible: true,
                defaultContent: "BDP",
            },
            fr: {
                name: "BDP",
                content: "BDP.png",
                isTextVisible: true,
                defaultContent: "BDP",
            },
            it: {
                name: "BDP",
                content: "BDP.png",
                isTextVisible: true,
                defaultContent: "BDP",
            },
            nl: {
                name: "BDP",
                content: "BDP.png",
                isTextVisible: true,
                defaultContent: "BDP",
            },
            pt: {
                name: "BDP",
                content: "BDP.png",
                isTextVisible: true,
                defaultContent: "BDP",
            },
        },
        shortName: "BDP",
    },
];

export const SETTING_SALE_MODE = "setting_sale_mode";
export const SETTING_LANGUAGE = "setting_language";
export const SETTING_PAYMENT_METHOD = "setting_Payment_Method";
export const SETTING_LOGO = "setting_Logo";
export const SETTING_INFORMATION_MODE = "setting_Information_mode";

export const CLICK_AND_COLLECT_ID = "f25e7c96-b5d3-4f2e-acd0-1500258283c2";

export const LOGO = "logo";
export const DATE_TIME_FORMAT = "DD/MM/YYYY [at] h:mm a";
export const DESIGNATION = "Designation";
export const REMARK = "Remark";
export const STATUS = "Status";
export const activities = [
    { value: "Restauration", label: "Restauration" },
    { value: "Supermarket", label: "Supermarket" },
    { value: "Liquor store", label: "Liquor store" },
    { value: "Retail store", label: "Retail store" },
    { value: "Essential products", label: "Essential products" },
    { value: "Pharmacy / Parapharmacy", label: "Pharmacy / Parapharmacy" },
    { value: "Bakery", label: "Bakery" },
    { value: "Florist", label: "Florist" },
    { value: "Pet shop", label: "Pet shop" },
];
export const roles = [
    { value: "Administrator", label: "Administrator" },
    { value: "User", label: "User" },
    { value: "Support", label: "Support" },
];
export const CUSTOMER_ACCOUNT_ID = "00fa26a0-0bc0-4986-9769-4ffe08d4498d";
export const CUSTOMER_ACCOUNT = "Customer account";
export const CUSTOMER_ACCOUNT_PDC = "8f561d9c-dac8-4037-89a6-0c2adb8a40bb";
export const LOYALTY_ACCOUNT = "Loyalty account";
export const NONE = "none";
export const CLICK_AND_COLLECT = "Retrait C&C";
export const GENERAL_TRANSITION_INITIAL_STATE = {
    prettyName: "None",
    timeout: 0,
    className: "none",
};

export const CUSTOMER_BENEFIT_INITIAL_STATE = {
    background: "",
    options: {
        customerBenefitHeader: {
            active: true,
            informationMessage: {
                active: true,
                resetContent: "Hello",
                languages: {
                    en: "Hello",
                    es: "Hola",
                    fr: "Salut",
                    it: "Ciao",
                    nl: "Hallo",
                    pt: "Olá",
                },
            },
            customerBalance: {
                active: true,
                resetContent: "you have (X) points",
                languages: {
                    en: "you have (X) points",
                    es: "tienes (X) puntos",
                    fr: "vous avez (X) points ",
                    it: "hai (X) punti",
                    nl: "Sie haben (X) Punkte",
                    pt: "você tem (X) pontos",
                },
            },
            customerAccountAdvantages: true,
            customerProfile: true,
        },
        promoCode: {
            active: true,
            resetContent: "scan or enter a promo code",
            languages: {
                en: "scan or enter a promo code",
                es: "escanea o ingresa un código de promoción",
                fr: "scanner ou saisir un code promo",
                it: "scansiona o inserisci un codice promozionale",
                nl: "Scannen Sie einen Aktionscode oder geben Sie ihn ein",
                pt: "digitalize ou insira um código promocional",
            },
            activeItems: [
                "049c04b4-9b01-42a6-8497-8b2a2aedd2d3",
                "049c04b4-9b01-42a6-8497-8b2a2aedd2d3",
            ],
        },
        gifts: {
            active: true,
            resetContent: "gifts",
            languages: {
                en: "gifts",
                es: "regalos",
                fr: "cadeaux",
                it: "regali",
                nl: "Geschenke",
                pt: "presentes",
            },
            activeItems: ["bbf6b88b-b5f4-438f-b8b0-0c7827083b53"],
        },
        rewards: {
            active: true,
            resetContent: "rewards",
            languages: {
                en: "rewards",
                es: "premios",
                fr: "récompenses",
                it: "premi",
                nl: "Auszeichnungen",
                pt: "prémios",
            },
            activeItems: ["c3f52255-7cd6-4024-b784-52a79172254a"],
        },
        nothanksButton: true,
        paymentWithLoyaltyBalance: true,
        cumulativeAdvantage: true,
        accountCreation: true,
        autoLaunchOnOrderTaking: true,
        autoLaunchOnPayButton: true,
    },
    actionsButtons: {
        "049c04b4-9b01-42a6-8497-8b2a2aedd2d3": {
            id: "049c04b4-9b01-42a6-8497-8b2a2aedd2d3",
            name: "Scan",
            active: true,
            resetContent: "scan",
            languages: {
                en: "scan.png",
                es: "scan.png",
                fr: "scan.png",
                it: "scan.png",
                nl: "scan.png",
                pt: "scan.png",
            },
        },
        "fb60d068-b372-4537-afd1-bb18d42da854": {
            id: "fb60d068-b372-4537-afd1-bb18d42da854",
            name: "Enter",
            active: true,
            resetContent: "enter",
            languages: {
                en: "enter.png",
                es: "enter.png",
                fr: "enter.png",
                it: "enter.png",
                nl: "enter.png",
                pt: "enter.png",
            },
        },
        "bbf6b88b-b5f4-438f-b8b0-0c7827083b53": {
            id: "bbf6b88b-b5f4-438f-b8b0-0c7827083b53",
            name: "use",
            active: true,
            resetContent: "use",
            languages: {
                en: "use.png",
                es: "use.png",
                fr: "use.png",
                it: "use.png",
                nl: "use.png",
                pt: "use.png",
            },
        },
        "c3f52255-7cd6-4024-b784-52a79172254a": {
            id: "c3f52255-7cd6-4024-b784-52a79172254a",
            name: "select",
            active: true,
            resetContent: "select",
            languages: {
                en: "select.png",
                es: "select.png",
                fr: "select.png",
                it: "select.png",
                nl: "select.png",
                pt: "select.png",
            },
        },
        "4bb339a4-ec7b-4d66-9fb0-9e71c1d6d983": {
            id: "4bb339a4-ec7b-4d66-9fb0-9e71c1d6d983",
            name: "logout",
            active: true,
            resetContent: "logout",
            languages: {
                en: "logout.png",
                es: "logout.png",
                fr: "logout.png",
                it: "logout.png",
                nl: "logout.png",
                pt: "logout.png",
            },
        },
    },
};

export const CREDIT_CARD_SHORT_NAME = "creditCard";

export const ELEMENTS_PAGES = "elements";
export const WAYS_PAGES = "ways";
export const VALID_WAYS_PAGES = [
    "standbyScreen",
    "salesMethods",
    "orderTaking",
    "finalMessage",
    "payment",
    "meansOfPayment",
    "printerOptions",
];
export const DEFAULT_ELEMENTS_PAGES = [
    "connection",
    "informationModes",
    "authenticationModes",
    "loyaltyConsommation",
    "informationModesConsommation",
];
